export class CategoryListingModel {
    PageNumber: number = 1;
    PageSize: number = 10;
    KeyWord: string = "";
}

export class CategoryList {
    id: number;
    categoryName: string;
    searchTags: string;
    dateFormatted: string;
    isActive: boolean;
}

export class CategoryResponseModel {
    CategoryList: Array<CategoryList> = [];
    TotalPages: number;
}

export class Category{
    categoryName: string;
    id: number;
    isSelected: boolean;
}